import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getTabularReportCSV = (
  userId,
  usergroupId,
  classId,
  trainingTypeId,
  categoryId,
  fromDate,
  toDate,
  countryId,
  stateId,
  cityId,
  storeId
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.TABULAR_REPORT.GET_TABULAR_REPORT_CSV(
      userId,
      usergroupId,
      classId,
      trainingTypeId,
      categoryId,
      fromDate,
      toDate,
      countryId,
      stateId,
      cityId,
      storeId
    )
  );
};

export default getTabularReportCSV;
